import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

let router: ReturnType<typeof createRouter>;

export function getRouter(queryClient?: QueryClient) {
  if (router) return router;

  router = createRouter({
    routeTree,
    context: {
      queryClient: queryClient ?? new QueryClient(),
    },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
